import React from 'react';
import Link from 'gatsby-link';

import LogoRow from '@marvelapp/marvel-ui/logo-row';
import Align from '@marvelapp/marvel-ui/align';

import logos from 'marketing-website/configs/pages/user-testing/logos.js';
import ArrowLink from 'marketing-website/components/commons/ArrowLink';

import styles from './style/logos.module.css';

export default function Logos() {
  return (
    <div className={styles.flex}>
      <LogoRow
        logos={logos}
        align="center"
        color="black"
        opacity={100}
        spacing="m"
      />
      <div className={styles.cta}>
        <Align type="center">
          <Link to="/customer-stories">
            <ArrowLink size="m" weight="semibold" colour="black">
              Read case studies
            </ArrowLink>
          </Link>
        </Align>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/pages/enterprise/Logos.js